import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=297a9bd8&scoped=true&"
import script from "./Managers.vue?vue&type=script&lang=js&"
export * from "./Managers.vue?vue&type=script&lang=js&"
import style0 from "./Managers.vue?vue&type=style&index=0&id=297a9bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a9bd8",
  null
  
)

export default component.exports